import "./App.css";
import WeatherContainer from "./components/WeatherContainer";

function App() {
  return (
    <div className="App">
      <h1>🌤️ PUDOMA Live Weather</h1>
      <WeatherContainer />
    </div>
  );
}

export default App;